import gql from 'graphql-tag'

export default gql`mutation createStaffUser($record: CreateOneStaffInput!){
    createStaffUser(record:$record){
      recordId
    }
  }`
